var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[(_vm.showHeader)?_c('div',{staticClass:"detail-head weight-sym",attrs:{"slot":"header"},slot:"header"},[_vm._t("header")],2):_vm._e(),_c('el-row',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }